import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { GraphView } from 'src/app/model/generic-graph';
import { NavigationOptions } from 'src/app/model/queryParams';
import { VerticalGraphType } from 'src/app/model/vertical-views';

@Component({
  selector: 'app-production-division-slide',
  templateUrl: './production-division-slide.component.html',
  styleUrls: ['./production-division-slide.component.scss']
})
export class ProductionDivisionSlideComponent {
  @Input() data!: any;
  @Input() navInfo!: NavigationOptions;
  @Input() navState!: NavigationOptions;

  constructor(private cdr: ChangeDetectorRef) { }


  public currentBUIndex: number = 0;
  public currentSBUIndex: number = 0;
  public currentSelectedColumnIndex!: number;  


  ngOnInit(): void {
    this.initDefaultNavInfo(); 
  }

  ngOnChanges(changes: SimpleChanges): void{
    if(changes["navState"]){
      this.currentBUIndex = changes["navState"].currentValue.bu;
      this.currentSBUIndex = changes["navState"].currentValue.sbu;
    }
  }

  /**
   * Initialize bar index and selected business unit, if graph was directly navigated to through url
   */
  private initDefaultNavInfo(): void {
    if (this.navInfo.column !== undefined && this.navInfo.column > -1 && this.navInfo.column < this.data.graph.data[this.currentBUIndex].graph.data.length) {
      this.onSelectGarphValue(this.navInfo.column);
    }
  }

  public onSelectGarphValue(index: number): void {
    this.currentSelectedColumnIndex = index;
    this.cdr.detectChanges();
  }

  public getBarType(data: GraphView): VerticalGraphType {
    if(data.title === "LY" || data.title === "BGT") {
      return VerticalGraphType.COMPARE_BAR;
    } else {
      return VerticalGraphType.SIMPLE_BAR;
    }
  }
}
